import twemoji from "@twemoji/api";

export function parse(string = ""): string {
  //@ts-ignore
  return twemoji.parse(string);
}
